import { Component, OnInit } from '@angular/core';
import { AlertController, ViewController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { MeteorObservable, ObservableCursor } from 'meteor-rxjs';
import * as _ from 'lodash';
import { App } from "ionic-angular";

import { Project } from 'api/models';
// import { getProject, getProjectManagers } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
// import { subscribeActiveCompany, subscribeActiveCompanyAdmins, getCompany, getCompanyAdmins } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { APP_TITLE } from '../../services/config';
import { HttpService } from '../../services/httpService';

@Component({
  selector: 'edit-project-info',
  templateUrl: 'edit-project-info.html'
})

export class EditProjectInfoComponent implements OnInit {
  project ? : Project | void;

  zipMask: Array < string | RegExp > ;
  phoneMask: Array < string | RegExp > ;

  constructor(
    private _app: App,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    public companyService: CompanyService,
    public projectService: ProjectService,
    private httpService: HttpService
  ) {
    this.zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
    console.log('edit project info page');
    const { projectId } = this.navParams.data;
    MeteorObservable.autorun().subscribe(() => {
      this.project = this.projectService.getProject(projectId);
    });
  }

  eventHandler(keyCode) {
      if(keyCode == 13) {
        let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }
  save(): void {
    if (!this.project) {
      return;
    }
    const locationChanges = _.pick(this.project, ['siteAddress', 'cityTown', 'state', 'zipCode', 'country', 'trailerPhone']);
    this.httpService.MeteorCall('updateProject', this.project._id, { ...locationChanges });
    this.viewCtrl.dismiss();
  }

  showError(title: string, message: string): void {
    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message,
      title: title || 'Oops',
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/edit-project-info/edit-project-info.ts